export default "__VITE_ASSET__647b5382__"